import { render } from "./AxertaNewLog.vue?vue&type=template&id=69f65997&scoped=true"
import script from "./AxertaNewLog.vue?vue&type=script&lang=js"
export * from "./AxertaNewLog.vue?vue&type=script&lang=js"

import "./AxertaNewLog.vue?vue&type=style&index=0&id=69f65997&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f65997"]])

export default __exports__